exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.transferts thead.is-group tr:nth-child(2) th:nth-child(5) {\n  background: #fff;\n  border: 0;\n  border-right: 1px solid #EBEEF5;\n}\n.transferts tr:nth-child(3) td:nth-child(5),\n.transferts .total td:nth-child(5) {\n  background: #fff;\n  border: 0;\n  border-right: 1px solid #EBEEF5;\n}\n.error input {\n  border: 1px solid red!important;\n}\n", ""]);

// exports
